import { render, staticRenderFns } from "./DriverSignupDocuments.vue?vue&type=template&id=160dd3ae&scoped=true&"
import script from "./DriverSignupDocuments.vue?vue&type=script&lang=js&"
export * from "./DriverSignupDocuments.vue?vue&type=script&lang=js&"
import style0 from "./DriverSignupDocuments.vue?vue&type=style&index=0&id=160dd3ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160dd3ae",
  null
  
)

export default component.exports